import { Slovak as DatePickerLocaleSk } from "flatpickr/dist/l10n/sk.js";
import { Czech as DatePickerLocaleCs } from "flatpickr/dist/l10n/cs.js";

export default {
    props: {
        uiLanguage: { type: String },
    },

    data() {
        return {
            componentName: this.$options.name,
            datetimePickerConfig: {
                dateFormat: 'Y-m-d', // interný formát (do v-model)
                altInput: true,      // zobrazí input inak
                altFormat: 'd.m.Y',  // zobrazený formát
                locale: this.getDatePickerLocale(this.uiLanguage)
            }
        }
    },

    methods: {
        getDatePickerLocale(langCode) {
            if(langCode == 'sk') return DatePickerLocaleSk;

            if(langCode == 'cs') return DatePickerLocaleCs;

            return null;
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/DatetimePickerConfig.js